const handleNavigation = ({ path, navigate }) => {
    console.log(`Navigating to ${path}`);
    console.log(`navigate function:`, navigate);

    if (typeof navigate === 'function') {
        navigate(path);
    } else {
        console.error('navigate is not a function:', navigate);
    }
};

export default handleNavigation;
